<button *xm-beta-feature [matTooltip]="TRS.historyChangesBtnTitle | translate" (click)="onClick(); $event.stopPropagation()" mat-icon-button>
    <mat-icon [matBadge]="'β'" matBadgeColor="accent" matBadgeSize="small" [matBadgeOverlap]="false">history</mat-icon>
</button>
